export const PlayIcon = ({ color = 'white', ...props }) => (
  <svg
    width={'46'}
    height={'47'}
    viewBox={'0 0 46 47'}
    fill={'none'}
    xmlns={'http://www.w3.org/2000/svg'}
    {...props}
  >
    <path
      d={'M0 5.19108C0 1.44998 3.95793 -0.96603 7.28537 0.743933L42.913 19.0529C46.5325 20.9129 46.5325 26.0871 42.913 27.9471L7.28537 46.2561C3.95793 47.9661 0 45.5501 0 41.809V5.19108Z'}
      fill={color}
    />
  </svg>

);
